// extracted by mini-css-extract-plugin
export default {"header":"styles_header__98M1r","menu":"styles_menu__mmkqa","searchContainer":"styles_searchContainer__R11Nk"};